import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';

import router from '@app/router';
import { PageLoader } from '@components/ui/PageLoader';
import { AuthProvider } from '@features/auth';
import { Toaster } from '@ui/sonner';

import ErrorBoundary from '../error-boundary';

const AppProvider = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader className="h-screen w-screen" />}>
        <AuthProvider>
          <RouterProvider
            router={router}
            fallbackElement={<PageLoader className="h-screen w-screen" />}
          />
        </AuthProvider>
      </Suspense>
      <Toaster />
    </ErrorBoundary>
  );
};

export default AppProvider;
